<!--
    Desarrollado por: Wuilmer garcia
    // Fecha: 2021/02/19
    // Modificado por: 
    // Fecha de ultima Modificacion:    
    // Causa: 

    ///////////////////////////////////////////////////////////
-->

<template>
    <div>
        <!-- formulario del Colegio -->

        <v-form ref="formDatos" lazy-validation>
            <v-dialog v-model="estadoModal" persistent scrollable max-width="100%">
                <v-card>
                    <v-card-title class="btn_otro">
                        <v-row class="d-flex justify-space-between py-0"> 
                            {{ formTitle }}
                            <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
                        </v-row>
                    </v-card-title> 

                    <v-divider></v-divider>

                    <v-card-text>

                        <!-- load edit events  -->
                        <v-row v-if="gestorBackground" class="mx-2" :style="[{'background-color':color_fondo}]">
                            <v-col cols="12" class="contenedor_texto mt-2">               
                                <v-col class="d-flex justify-space-between titulo-text mb-4">
                                    <h4>Fondo</h4>
                                    <v-btn fab dark x-small class="btn_style3" @click="gestorBackground=false"><v-icon dark>fa-times</v-icon></v-btn>
                                </v-col>

                                <v-color-picker v-model="color_fondo"></v-color-picker>
                            </v-col>

                            <v-row justify="end"> 
                                <v-btn class="btn_block_style2 mr-4" dark  @click="saveBackground(columna, tag); gestorBackground=false">Agregar</v-btn>
                            </v-row>
                        </v-row>
                            
                        <v-row v-if="gestionEditor" class="mx-2" :style="[{'background-color':color_fondo}]">
                            <v-col cols="12" class="contenedor_texto mt-2">                       
                                <v-col class="d-flex justify-space-between titulo-text mb-4">
                                    <h4>{{tipoOperacion}}</h4>
                                    <v-btn fab dark x-small class="btn_style3" @click="gestionEditor=false"><v-icon dark>fa-times</v-icon></v-btn>                    
                                </v-col>

                                <ckeditor v-model="editorData" :config="editorConfig"></ckeditor>
                            </v-col>

                            <v-row justify="end">
                                <v-btn v-if="evento=='agregar'" class="btn_block_style2" dark  @click="saveText(tag)">Agregar</v-btn>
                                <v-btn v-if="evento=='editar'" class="btn_block_style2" dark  @click="doneEditText(indexTarea)">Editar</v-btn>
                            </v-row>
                        </v-row>

                        <!-- END load edit events 
                            <v-col cols="4" :class="ColumnaActiva01" class="pt-0" style="min-height:400px">     
                         -->

                        <v-row class="mx-1">
                            
                            <v-col cols="12">


                                <v-card outlined class="mb-3">

                                    <v-row>                                        
                                        <v-col cols="12" md="7" lg="8" class="py-0">
                                            <v-text-field label="Nombre Plantilla" type="text" v-model="json_contenido.nombre_template"></v-text-field>
                                        </v-col>
                                        
                                        <v-col cols="12"  md="5" lg="4" class="py-0">
                                            <v-radio-group row  v-model="json_contenido.estado_template" label="Estado ">
                                                <v-radio :label="`Activo`" :value="1" color="teal"></v-radio>
                                                <v-radio :label="`Inactivo`" :value="0" color="error"></v-radio>
                                            </v-radio-group>                                        
                                        </v-col>
                                    </v-row>

                                </v-card>

                                <v-card outlined class="text-center mb-3" :style="[{'background-color':json_contenido.color_fondo_titulo}]">
                                    <div v-html="json_contenido.titulo" class="my-2"></div>                                    

                                    <v-btn class="btn_editar mr-2" fab x-small title="Editar" @click="activateElement('titulo')">
                                        <v-icon small>fa-pencil-alt</v-icon>
                                    </v-btn>

                                    <v-btn class="btn_palette mr-2" fab x-small title="Editar Color de Fondo" @click="activateBackground('titulo', -1)">
                                        <v-icon small>fas fa-palette</v-icon>
                                    </v-btn>
                                    
                                </v-card>



                                <v-card outlined class="text-center" :style="[{'background-color':json_contenido.color_fondo_subtitulo}]">
                                    <div v-html="json_contenido.subtitulo" class="my-2"></div>
                                    <v-btn class="btn_editar mr-2" fab x-small title="Editar" @click="activateElement('subtitulo')">
                                        <v-icon small>fa-pencil-alt</v-icon>
                                    </v-btn>

                                    <v-btn class="btn_palette mr-2" fab x-small title="Editar Color de Fondo" @click="activateBackground('subtitulo', -1)">
                                        <v-icon small>fas fa-palette</v-icon>
                                    </v-btn>

                                    <v-btn class="btn_eliminar mr-2" fab x-small title="Eliminar" @click="deleteElement('subtitulo')">
                                        <v-icon>fa-trash-alt</v-icon>
                                    </v-btn>  
                                </v-card>
                            </v-col>

                            <!--  ************************ 
                                INICIO VISUALIZAR COLUMNA 
                                ************************** -->
                            
                            <!--  ## START Contenido Diapositiva COL1    justify="space-between" -->
                            <v-col cols="4" :class="ColumnaActiva01" class="pt-0">     
                                <v-row class="d-flex justify-center mb-2" style="background-color:#0277bd; color: #fff !important;">
                                    <h3>Columna 1</h3>
                                </v-row>         

                                <v-row class="d-flex justify-center my-2" >  
                        
                                    <v-btn class="btn_block_style2 mr-2 mb-2" small dark  @click="activateElement('texto', 1)">
                                        Texto<v-icon class="ml-3" >fa-text-width</v-icon>
                                    </v-btn> 
                                    <v-btn class="btn_block_style2 mr-2 mb-2" small dark   title="Editar Color de Fondo" @click="activateBackground('columna', 1)">
                                        Color Fondo<v-icon class="ml-3" >fas fa-palette</v-icon>
                                    </v-btn>           

                                </v-row>

                                <!-- style="min-height:100vh" -->
                                
                                <div v-for="(item, index) of json_contenido.seccion1" :key="item.id"> 

                                    <v-card class="ma-2" :style="[{'background-color':json_contenido.color_fondo_col01}]" >
                                        <v-container>
                                            <v-row justify="space-between">
                                                <v-col cols="">
                                                    <template>
                                                        <div>
                                                            <v-btn v-if="item.nombre!=''" title="Editar" @click="editText(index, 1)" class="mx-2 pl-1" fab dark x-small color="warning" ><v-icon small >fa-pencil-alt</v-icon></v-btn>
                                                            <v-btn title="Eliminar" @click="deleteObjeto(index, 1)" class="mx-2 pl-1" fab dark x-small color="error"><v-icon small >fas fa-trash</v-icon></v-btn>
                                                        </div>
                                                    </template>  

                                                    <template v-if="item.nombre!=''">
                                                        <span class="ma-2" v-html="item.nombre"></span> 
                                                    </template>

                                                    
                                                </v-col>

                                            </v-row>
                                        </v-container>
                                    </v-card>
                            
                                </div>
                                
                            </v-col>
                            <!--  ## END Contenido Diapositiva COL1  -->
                            
                            
                            <!--  ## START Contenido Diapositiva COL2  -->
                            <v-col cols="4 "  :class="ColumnaActiva02" class="pt-0"> 

                                <v-row class="d-flex justify-center mb-2" style="background-color:#01579b; color: #fff !important;">
                                    <h3>Columna 2</h3>
                                </v-row>             

                                <v-row class="d-flex justify-center my-2">  
                        
                                    <v-btn class="btn_block_style2 mr-2 mb-2" small dark  @click="activateElement('texto', 2)">
                                        Texto<v-icon class="ml-3" >fa-text-width</v-icon>
                                    </v-btn>  
                                    <v-btn class="btn_block_style2 mr-2 mb-2" small dark   title="Editar Color de Fondo" @click="activateBackground('columna', 2)">
                                        Color Fondo<v-icon class="ml-3" >fas fa-palette</v-icon>
                                    </v-btn>           

                                </v-row>

                                <div v-for="(item, index2) of json_contenido.seccion2" :key="item.id">                             

                                    <v-card class="ma-3" :style="[{'background-color':json_contenido.color_fondo_col02}]" >
                                        <v-container>
                                            <v-row justify="space-between">
                                                <v-col cols="">
                                                
                                                    <template>
                                                        <div class=" ">
                                                            <v-btn v-if="item.nombre2!=''" @click="editText(index2, 2)"  class="mx-2 pl-1" fab dark x-small color="warning" title="Editar" ><v-icon small >fa-pencil-alt</v-icon></v-btn>
                                                            <v-btn @click="deleteObjeto(index2, 2)" class="mx-2 pl-1" fab dark x-small color="error" title="Eliminar"><v-icon small >fas fa-trash</v-icon></v-btn>
                                                        </div>
                                                    </template> 


                                                    <!---------->

                                                    <template v-if="item.nombre2!=''">  
                                                        <span class="ma-2" v-html="item.nombre2"></span> 
                                                    </template>



                                                    
                                                </v-col>

                                            <!--  <v-col cols="auto" class="text-center pl-0" >
                                                    <v-row class="flex-column ma-0 fill-height" justify="center"></v-row>
                                                </v-col> -->
                                            </v-row>
                                        </v-container>
                                    </v-card>                    
                                
                                </div>
                
                            </v-col>
                            <!--########################################### end 2 -->

                            <!--########################################### ini 3 -->
                            <v-col cols="4 " :class="ColumnaActiva03" class="pt-0">

                                <v-row class="d-flex justify-center mb-2" style="background-color:#0277bd; color: #fff !important;">
                                    <h3>Columna 3</h3>
                                </v-row>  

                                <v-row class="d-flex justify-center my-2">  
                        
                                    <v-btn class="btn_block_style2 mr-2 mb-2" small dark  @click="activateElement('texto', 3)">
                                        Texto<v-icon class="ml-3" >fa-text-width</v-icon>
                                    </v-btn>
                                    <v-btn class="btn_block_style2 mr-2 mb-2" small dark   title="Editar Color de Fondo" @click="activateBackground('columna', 3)">
                                        Color Fondo<v-icon class="ml-3" >fas fa-palette</v-icon>
                                    </v-btn>            

                                </v-row>
                        
                                <div v-for="(item, index3) of json_contenido.seccion3" :key="item.id">                
                                
                                    <v-card class="ma-3" :style="[{'background-color':json_contenido.color_fondo_col03}]" >
                                        <v-container>
                                            <v-row justify="space-between">
                                                <v-col cols="">
                                                    <template>
                                                        <div>
                                                            <v-btn v-if="item.nombre3!=''" @click="editText(index3, 3)" class="mx-2 pl-1" fab dark x-small color="warning" title="Editar"><v-icon small >fa-pencil-alt</v-icon></v-btn>
                                                            <v-btn  @click="deleteObjeto(index3, 3)" class="mx-2 pl-1" fab dark x-small color="error" title="Eliminar"><v-icon small >fas fa-trash</v-icon></v-btn>
                                                        </div>
                                                    </template>


                                                    <template v-if="item.nombre3!=''">  
                                                        <span class="ma-2" v-html="item.nombre3"></span> 
                                                    </template>

                                                

                                                </v-col>

                                            </v-row>
                                        </v-container>
                                    </v-card>
                            
                                </div>                
                        
                            </v-col>
                            <!-- Contenido Diapositiva end -->
                            <!--########################################### end 3 -->
                            
                        </v-row>

                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer> 
                        <v-btn class="btn_style3" dark  @click="$emit('close')">Cancelar</v-btn>

                        <v-btn class="btn_block_style2" dark  v-if="this.parametros.evento=='editar'" @click="saveItem();">Guardar Cambios</v-btn>
                        <v-btn class="btn_block_style2" dark  v-if="this.parametros.evento=='agregar'" @click="saveItem();">Guardar</v-btn>
                    
                     
                    </v-card-actions>
                        <span v-if="test">
                            <code>parametros :{{parametros}} </code> 
                            <code>prueba: {{json_prueba}} </code>
                            <code>json_contenido:  {{json_contenido}} </code>
                        </span>
                     </v-card>
               
            </v-dialog>


           
        </v-form>

        <!-- fin modal del Colegio -->



    </div>
</template>

<script>

    import axios from "@/helpers/axios";
    import {mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
        name:'modalColegioFormulario',

        // props:['estadoModal' , 'parametros'],
        props:{
            parametros:{
                type:Object
            },
            estadoModal:{
                type:Boolean
            },
        },



        data(){
            return{
                 datoLogin: sessionStorage, 
                evento: null,
                compName:"",
                test:false,
                estadoModalConfig: false,
                parametroConfigVisor : [],
                
                columna : -1,
                columna1: true,
                columna2: false,
                columna3: false,
                gestionEditor:false,
          

                gestorBackground: false,           
                color_fondo:  "#B5E6FF",
                            
                tipoOperacion:'',
                tag:'',
                editorData:'',
                barrarProgreso:false,
     
                paramComponente:{ 'id_submodulo':22, "id_modulo": 4},    

                indexTarea : -1,
                nombre_archivo:'',

                json_contenido:{ },

                json_prueba : {},

                // editorData: "<p>Content of the editor.  </p>",
                editorConfig: {
                    height : 120,
                    extraPlugins:
                        "colorbutton,font,colordialog,justify, tableresize,liststyle",
                    toolbar: [
                        { name: 'styles', items: [ 'Styles', 'Format', 'Font', 'FontSize' ] },
                        { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-' ] },
                        { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
                        [ 'Undo', 'Redo' ], 
                            { name: 'document', items: [ 'Source', '-','Preview'   ] },
                        { name: 'tools', items: [ 'Maximize', 'ShowBlocks' ] },
                        '/',
                        { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
                        { name: 'links', items: [ 'Link', 'Unlink', 'Anchor' ] },
                        { name: 'insert', items: ['Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe' ] },                        
                    ],        
                },

            }
        },
       
        mounted() {
            //this.listarTemas();
            this.loadMain()
        },

        //computadas
        computed: {
         
            ...mapGetters('login', [ 'componenteEvento']),
           
            formTitle () {
                return this.parametros.evento === 'agregar' ? 'CREAR PLANTILLA' : 'EDITAR PLANTILLA'
            },

                   
        
            ColumnaActiva01() {
                return (this.columna1) ?  'warning p-0' :'grey lighten-1'
            },
            ColumnaActiva02() {
                return (this.columna2) ?  'warning p-0' :'grey lighten-3'
            },
            ColumnaActiva03() {
                return (this.columna3) ?  'warning p-0' :'grey lighten-1'
            },

             // Maxima Fecha Calendario
            maxDate(){
                return  new Date().toISOString().substr(0, 10)               
            },

            computedDateFormatted () {
                return this.formatDate(this.editedItem.fec_constitucion)
            },
           
            fecnacDateFormatted () {
                return this.formatDate(this.datos.fecnac_persona)
            },

        },

        
        
        watch: {
            // cada vez que la pregunta cambie, esta función será ejecutada
            estadoModal() {
                if(this.estadoModal){
                    this.loadMain()                    
                }else{   
                    //this.parametros = {}
                    this.limpiarForm()
                 
                }
            }
        },
        

        methods: {

            ...mapActions('login',['parametroComponente'] ),
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            
            
            loadMain(){

                this.limpiarForm() 
                // this.$refs.formDatos.resetValidation()
                              
                if(this.parametros.evento=='editar'){
                    this.editItem(this.parametros.item) 
                }

            },

            async editItem (item) {

                // JSON.parse(this.prueba[0].json_contenido)
                // let objectNew = JSON.parse(item.json_contenido)
                // this.json_prueba =  typeof(objectNew);
                // this.json_prueba =  objectNew.color_fondo_titulo; 
                

                this.json_contenido  = JSON.parse(item.json_contenido)
                this.json_contenido.estado_template = item.estado_template
        
            },

            limpiarForm(){
                
                this.json_contenido ={
                                        id_usuario: sessionStorage.id,
                                        id_colegio:sessionStorage.id_colegio,
                                        nombre_template: null,
                                        titulo: '<span style="font-family:Comic Sans MS,cursive"><span style="font-size:36px">ESCRIBE AQUI EL TITULO</span></span>',
                                        subtitulo:  '<span style="font-family:Comic Sans MS,cursive"><span style="font-size:28px">ESCRIBE AQUI EL SUBTITULO</span></span>', 
                                        background:            "#FFFFFF",
                                        color_fondo_titulo:    "#FFFFFF",
                                        color_fondo_subtitulo: "#FFFFFF",
                                        color_fondo_col01:     "#7BBDE6",
                                        color_fondo_col02:     "#E4F5FF",
                                        color_fondo_col03:     "#7BBDE6", 
                                        seccion1: [{nombre:  '<span style="font-family:Comic Sans MS,cursive"><span style="font-size:22px">Texto de Ejemplo Columna1</span></span>' }],
                                        seccion2: [{nombre2: '<span style="font-family:Comic Sans MS,cursive"><span style="font-size:22px">Texto de Ejemplo Columna2</span></span>'  }],
                                        seccion3: [{nombre3: '<span style="font-family:Comic Sans MS,cursive"><span style="font-size:22px">Texto de Ejemplo Columna3</span></span>'  }],
                                        estado_template:1
                                    },


                this.editedItem = {
                    id_usuario: this.datoLogin.id, id_colegio: this.datoLogin.id_colegio
                }
               
            },


            /////////////////////////////
            // START global function  //
            activateColumna(columna){

                let error = true
                if(columna == 1){
                    this.columna1 = true
                    this.columna2 = false
                    this.columna3 = false
                    error = false
                }

                if(columna == 2){
                    this.columna1 = false
                    this.columna2 = true
                    this.columna3 = false
                    error = false
                }

                if(columna == 3){
                    this.columna1 = false
                    this.columna2 = false
                    this.columna3 = true
                    error = false
                }

                if(columna == -1){
                    this.columna1 = false
                    this.columna2 = false
                    this.columna3 = false
                    error = false
                }

                if(error){
                    return true  
                }else{                                    
                    return false
                }
                
            },


             clearElement(){          
                
                this.gestorBackground = false   
                this.gestionEditor    = false
                
            },
             

            // END global function       //
            ///////////////////////////////


            activateElement(item, columna){

                this.activateColumna(columna)
                this.clearElement()
                this.tag = item
                this.evento = "agregar"
               

                if(item==='titulo')
                {
                    this.gestionEditor = true
                    this.tipoOperacion = 'TITULO'
                    this.editorData    = this.json_contenido.titulo
                    this.color_fondo   = this.json_contenido.color_fondo_titulo
                }
                
                if(item==='subtitulo')
                {
                    this.gestionEditor = true
                    this.tipoOperacion = 'SUBTITULO'
                    this.editorData    = this.json_contenido.subtitulo
                    this.color_fondo   = this.json_contenido.color_fondo_subtitulo
                }

                if(item==='texto')
                {   
                    this.gestionEditor = true
                    this.tipoOperacion = 'TEXTO PARA CONTENIDO'
                    this.editorData    = '<p>ESCRIBE AQUI EL TEXTO</p>'
                    this.color_fondo  = '#FFFFFF'
                }

            },
          
            deleteElement(){
                this.json_contenido.subtitulo = ""
            },

         

            addColumnaText(){
                let error = true

                if(this.columna1){
                    error = false
                    this.json_contenido.seccion1.push({
                        taskid: '',
                        nombre: this.editorData,
                        estado: false,                        
                    })
                }

                if(this.columna2){
                    error = false
                    this.json_contenido.seccion2.push({
                        taskid2: '',
                        nombre2: this.editorData,                        
                        estado2: false,
                        
                    })
                }

                if(this.columna3){
                    error = false              
                    this.json_contenido.seccion3.push({
                        taskid3: '',
                        nombre3: this.editorData,   
                        estado3: false,
                        
                    })                
                }

                if(error){            
                    this.setEnviarMens({tipo:"E", mensaje: `Debe seleccionar una columna`, tiempo:null})         
                }
                
                else{
                    this.gestionEditor = false
                    this.editorData    = "" 
                }            
            },


            saveText(tag){
                
                if(tag === 'titulo'){
                    this.json_contenido.titulo = this.editorData
                    this.gestionEditor=false
                }
            
                if(tag === 'subtitulo'){
                    this.json_contenido.subtitulo = this.editorData
                    this.gestionEditor=false
                }       
            
                if(tag === 'texto'){  
                    this.addColumnaText()    
                }
            },


            editText(index, columna){
                
                this.tag =  "texto"
                this.evento = "editar"
                this.gestionEditor = true
                this.indexTarea = index
                let error = this.activateColumna(columna) 

                if(columna == 1){ 
                    
                    this.editorData = this.json_contenido.seccion1[index].nombre 
                    this.color_fondo = this.json_contenido.color_fondo_col01               
                }

                if(columna == 2){ 
                    // this.editorData = this.tareas2[index].nombre2
                    
                    this.editorData = this.json_contenido.seccion2[index].nombre2
                    this.color_fondo = this.json_contenido.color_fondo_col02
                }

                if(columna == 3){ 
                    this.editorData = this.json_contenido.seccion3[index].nombre3
                    this.color_fondo = this.json_contenido.color_fondo_col03
                }

                if(error){
                    this.setEnviarMens({tipo:"W", mensaje: `Error en editar Texto`, tiempo:null})
                }
                
            },
            
            doneEditText: function(index){  
                this.gestionEditor = false

                if(this.columna1){
                    
                    this.json_contenido.seccion1[index].nombre = this.editorData 
                }

                if(this.columna2){
                    this.json_contenido.seccion2[index].nombre2 = this.editorData
                }

                if(this.columna3){
                    this.json_contenido.seccion3[index].nombre3 = this.editorData
                }
            },

            // END edit text  //
            ////////////////////



            activateBackground(tag, columna){
                this.columna = columna
                this.tag = tag
                this.clearElement()
                let error = true

                if (tag == "titulo" && columna == -1){                    
                    this.color_fondo = this.json_contenido.color_fondo_titulo
                    error = false
                }

                if (tag == "subtitulo" && columna == -1){
                    this.color_fondo = this.json_contenido.color_fondo_subtitulo
                    error = false
                }                

                if(columna == 1){
                    this.color_fondo = this.json_contenido.color_fondo_col01
                    error = false
                }

                if(columna == 2){
                    this.color_fondo = this.json_contenido.color_fondo_col02
                    error = false
                }

                if(columna == 3){
                    this.color_fondo = this.json_contenido.color_fondo_col03
                    error = false
                }
                
                if(error){
                    this.setEnviarMens({tipo:"S", mensaje: `Error interno en configuración fondo`, tiempo:null})
                }else{
                    this.gestorBackground = true
                    this.activateColumna(columna)
                }
            },



            saveBackground(columna, tag){

                if (tag == "titulo" && columna == -1){                    
                    this.json_contenido.color_fondo_titulo = this.color_fondo                     
                }

                if (tag == "subtitulo" && columna == -1){
                    this.json_contenido.color_fondo_subtitulo = this.color_fondo
                }                

                if(columna == 1){
                    this.json_contenido.color_fondo_col01 = this.color_fondo 
                }

                if(columna == 2){
                    this.json_contenido.color_fondo_col02 = this.color_fondo 
                }

                if(columna == 3){
                    this.json_contenido.color_fondo_col03 = this.color_fondo
                }


            },


            
         
            // cargar json mirror
            async saveItem(){

               let error = false
               let mensaje = null
                // Validar Tareas
                if(this.json_contenido.seccion1.length ==  0 || 
                    this.json_contenido.seccion2.length ==  0 || 
                    this.json_contenido.seccion3.length ==  0){
                     
                     mensaje = "Error en ingresar informacion requeridas para las columnas"
                }
                
                if(this.json_contenido.nombre_template == "" ||this.json_contenido.nombre_template == null ){
                     
                     mensaje = "Debe Ingresar La descripción de Plantilla"
                }
                
                    
                if(error){
                    this.setEnviarMens({tipo:"W", mensaje, tiempo:5000})

                }else{

                    try{
                        
                        let  res = ""
                        if(this.parametros.evento == 'agregar'){   

                            let params = {js: this.json_contenido}
                            res = await  axios.post('/manager/contenido/template/',params )  
                            this.setEnviarMens({tipo:`${res.data.messageT}`, mensaje: `${res.data.message}`, tiempo:6000})
       
                        }

                        if(this.parametros.evento == 'editar'){

                            // this.editedItem = Object.assign(this.editedItem, {id_usuario:this.datoLogin.id});
                            // this.datos = Object.assign(this.datos, {id_usuario:this.datoLogin.id,  evento: this.evento});
                            let params = {js: this.json_contenido}
                            res = await axios.put(`/manager/contenido/template/${this.parametros.item.id}`,params)
                        }
                     
                        this.setEnviarMens({tipo:`${res.data.messageT}`, mensaje: `${res.data.message}`, tiempo:6000})
                        this.json_contenido = []
                        this.$emit('close')

                    }

                    catch(error){
                        //console.log(handleError(error))
                        console.log(error)                        
                        this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                    }
                
                }
                                    
            },
            

            //################################### Editar seccion 1 end
            //################################## Eliminar Tareas ini
            
            deleteObjeto: function(index, columna){

                let error = true  
                if(columna == 1){
                    error = false 
                    this.json_contenido.seccion1.splice(index, 1)  
                }

                if(columna == 2){
                    error = false 
                    this.json_contenido.seccion2.splice(index, 1)
                }

                if(columna == 3){
                    error = false 
                    this.json_contenido.seccion3.splice(index, 1)
                }

                if(error){
                    this.setEnviarMens({tipo:"E", mensaje:`Error en borrar objeto`, tiempo:5000})
                }
            
            },
            //################################## Eliminar Tareas end

           

        },
    }
</script>


<style scoped>
</style>